import React from "react";
import ForgotPassword from "../../views/ForgotPassword";
import ResetPassword from "../../views/ResetPassword";

const ResetPasswordPage = () => {
  return (
    <div className="h-screen">
      <ResetPassword />
    </div>
  );
};

export default ResetPasswordPage;
